export var statusViewPropState = ['progress', 'error', 'info', 'success'];